import React, { Fragment } from 'react'
import HeaderBotton from '../../../components/HeaderBottom'
import HeroSlider from '../../../components/HeroSlider'
import ServiceArea from '../../../components/ServiceArea'
import ContactArea from '../../../components/ContactArea'

import FooterArea from '../../../components/FooterArea'
// images


// images
import portfolio1 from '../../../images/studies/1.jpg'
import portfolio2 from '../../../images/studies/2.jpg'
import portfolio3 from '../../../images/studies/3.jpg'
import portfolio4 from '../../../images/studies/4.jpg'
import portfolio5 from '../../../images/studies/5.jpg'
import {grey} from "@mui/material/colors";
import title from "../../../components/Title";

const aboutText = [
    { text: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at ,' },
    { text: 'and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum' },
]

const heroSliders = [
    {
        background: "#d4d4d4",
        title: 'IMSSPIRA',
        subTitle: 'ESPECIALISTAS EN RETIRO POR DESEMPLEO',
        text: '¿Te quedaste sin trabajo y necesitas retirar tu AFORE? ' +
            ' Te ayudamos a recuperar tu dinero de forma rápida y segura.',
        button: 'Our Team'
    },
]




const services = [
    {
        icon: 'flaticon',
        title: 'No estar vigente en IMSS',
        content: 'No estar vigente en IMSS .....',

    },
    {
        icon: 'flaticon',
        title: '5 años desde tu último retiro',
        content: '5 años desde tu último retiro',
    },
    {
        icon: 'flaticon',
        title: 'Haber laborado 2 años con seguro',
        content: 'Haber laborado 2 años con seguro',
    },
    {
        icon: 'flaticon',
        title: 'Contar con CURP y NSS',
        content: 'Necesario para prevalidacion',
    },
]

const portfolioItem = [
    { images: portfolio1, title: 'General Service', subtitle: 'Corporate' },
    { images: portfolio2, title: 'Personal Issue', subtitle: 'General' },
    { images: portfolio3, title: 'Business Accounting', subtitle: 'Business' },
    { images: portfolio4, title: 'Accounting issue', subtitle: 'Criminal' },
    { images: portfolio5, title: 'Business Accounting', subtitle: 'Family Issue' }
]

const HomePageOne = () => {
    return (
        <Fragment>
            <header className="headerArea">
                <HeaderBotton className="headerBottomArea" />
            </header>
            <HeroSlider 
                sliders={heroSliders}
                className="heroSliderArea" />
            <ServiceArea
                className="ourServiceArea"
                title="Te ayudamos a recuperar tu dinero de forma rápida y segura."
                subTitle="¿Qué hacemos por ti?"
                services={services}
            />
            {/* <TeamMember
                id="team-member"
                title="Our Team"
                infoTeam="We are cousins and moms who value our family above all. Because of these values, we bring a fresh, compassionate perspective and contemporary approach to protecting your family’s future. We were inspired to start this firm because we recognized a crucial need: families and individuals like us who seek personalized, accessible estate planning services."
                subTitle="Meet Our Experts"
                className="teamArea"
                slider={true}
            />*/}
            <ContactArea
                className="contactArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default HomePageOne